import { render } from "./WaitingRoom.vue?vue&type=template&id=099a7f8c&scoped=true&ts=true"
import script from "./WaitingRoom.vue?vue&type=script&lang=ts"
export * from "./WaitingRoom.vue?vue&type=script&lang=ts"

import "./WaitingRoom.vue?vue&type=style&index=0&id=099a7f8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099a7f8c"]])

export default __exports__